import React from 'react';
import styled from 'styled-components';
import * as colors from '../../util/colors';
import { Heading, WYSIWYG, NotationBlock } from '../../util/typography';
import ComponentWrapper from '../layout/ComponentWrapper';
import { createMarkup } from '../../util/functions';
import { BoxedDefinitionList, ExclamationList } from '../../components';

const StyledComponentWrapper = styled(ComponentWrapper)`
    border-bottom: 1px solid ${colors.pebble};
    max-width: 824px;

    .underline {
        text-decoration: underline;
    }

    .separator {
        
        background-color: unset;
        border-width: 0;
        border-top: 1px solid ${colors.pebble};
        margin-block: 32px;
    }

    &:last-child {
        border-bottom: none;
    }

    .underline {
        text-decoration: underline;
    }

    .separator {
        border-width: 0;
        border-top: 1px solid ${colors.pebble};
        margin-block: 32px;
    }
`;

const IndicationDosingContent = styled.article``;

const IndicationDosingTitle = styled(Heading.H3)`
    margin-bottom: ${({ largeMargin }) => 
    largeMargin ? '-20px' : '-10px'};
`;

const DosingCallout = styled(WYSIWYG)`
    margin: 30px 0 40px 0;
    font-size: 20px;
`;
const BottomBorder = styled(ComponentWrapper)`
border-top: 1px solid ${colors.pebble};
padding-top:40px;

[class*="BoxedDefinitionList__ItemText-"] ul > li:last-child {
  margin-bottom: 2px;
}
[class*="BoxedDefinitionList__ItemTextContainer-"] {
  margin-bottom: 4px;
}
`;

// const StyledExclamationList = styled(ExclamationList)`
// margin-top: 0;
// `;

const IndicationDosing = props => {
    if (!props.body) return null; 
    const adultDosingHeading = `Dosing${props.body.adult?.headingAddon || ''}`;
    const pediatricDosingHeading = `Dosing${props.body.pediatric?.headingAddon || ''}`;
    const administrationDosingHeading =`KEYTRUDA QLEX: Administration Information${props.body.administration?.headingAddon || ''}`;
    const durationHeading = 'Duration and Timing of Treatment';
    

    return (
        <StyledComponentWrapper>
            <IndicationDosingContent>
               
                <IndicationDosingTitle dangerouslySetInnerHTML={createMarkup(props.title)} />
                {props.body?.adult && 
                (<BoxedDefinitionList
                    title='Adult Patients'
                    arTitle={true}
                    items={[
                        {
                            header: adultDosingHeading,
                            description: `<ul>
                                            ${props.body.adult.dosing}
                                        </ul>
                            `
                        },
                        {
                            header: durationHeading,
                            description: props.body.adult.duration
                        },
                    ]}
                />)}
                
                {props.body?.pediatric && 
                (<BoxedDefinitionList
                    title='Pediatric Patients'
                    arTitle={true}
                    items={[
                        {
                            header: pediatricDosingHeading,
                            description: props.body.pediatric.dosing
                        },
                        {
                            header: durationHeading,
                            description: props.body.pediatric.duration
                        },
                    ]}
                />)}

                
                {props.body?.callout &&
                (
                    <DosingCallout>
                        <a href={props.body.callout.url}>{props.body.callout.text}</a>
                    </DosingCallout>
                )}
                {props.body?.patientSelection && 
                (
                    <ExclamationList 
                        title='Patient Selection'
                        arTitle={true}
                        items={props.body.patientSelection}
                    />
                )}

                {props.body?.patientSelectionCombination && 
                    <ExclamationList 
                        title='Patient Selection for Combination Therapy'
                        arTitle={true}
                        items={props.body.patientSelectionCombination}
                    />
                }            
                    
                {props.body?.administration && (
                    <BottomBorder>
                        <>
                            <IndicationDosingTitle largeMargin dangerouslySetInnerHTML={createMarkup(props.body.administration.header)} />

                            <BoxedDefinitionList
                                // title='Pediatric Patients'
                                arTitle={true}
                                items={[
                                    {
                                        header: administrationDosingHeading,
                                        description: props.body.administration.dosing,
                                        link:props.body.administration.link
                                    },
                                ]}
                            />
                         </>
                    </BottomBorder> )
                }
                              
                {(props.definitions || props.footnotes) && <NotationBlock definitions={props.definitions} footnotes={props.footnotes} />}
                
            </IndicationDosingContent>
        </StyledComponentWrapper>
    );
};

export default IndicationDosing;